module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/user_way_mobile-8630a55f25cce850da8b8bc5a0dba0c2.jpg";